module.exports = __webpack_public_path__ + "img/stretch--genre2_tab-icon.d30db927.png";